import {
  applyRemoveWhiteBackgroundToCanvas,
  removeBlackFromImageData,
} from "@/home/remove-white-bg";
import type { PixelRect } from "@/home/sheet-crop";
import {
  RANK_BADGE_SHEET_HEIGHT,
  RANK_BADGE_SHEET_WIDTH,
} from "@/rank/leaderboard-types";

const SHEET_ASPECT = RANK_BADGE_SHEET_WIDTH / RANK_BADGE_SHEET_HEIGHT;

export function maxRankBadgeCropRect(imageWidth: number, imageHeight: number): PixelRect {
  const iw = Math.max(1, imageWidth);
  const ih = Math.max(1, imageHeight);
  let sw: number;
  let sh: number;
  if (iw / ih >= SHEET_ASPECT) {
    sh = ih;
    sw = ih * SHEET_ASPECT;
  } else {
    sw = iw;
    sh = iw / SHEET_ASPECT;
  }
  sw = Math.min(sw, iw);
  sh = Math.min(sh, ih);
  return {
    sx: (iw - sw) / 2,
    sy: (ih - sh) / 2,
    sw,
    sh,
  };
}

export function clampRankBadgeCropRect(
  rect: PixelRect,
  imageWidth: number,
  imageHeight: number,
): PixelRect {
  const iw = Math.max(1, imageWidth);
  const ih = Math.max(1, imageHeight);
  const sw = Math.min(rect.sw, iw);
  const sh = Math.min(rect.sh, ih);
  const sx = Math.min(Math.max(0, rect.sx), iw - sw);
  const sy = Math.min(Math.max(0, rect.sy), ih - sh);
  return { sx, sy, sw, sh };
}

export type RankBadgeCropExportOptions = {
  removeWhiteBg?: boolean;
  removeBlackBg?: boolean;
};

export function exportRankBadgeSheetCrop(
  image: HTMLImageElement,
  rect: PixelRect,
  options?: RankBadgeCropExportOptions,
): string {
  const canvas = document.createElement("canvas");
  canvas.width = RANK_BADGE_SHEET_WIDTH;
  canvas.height = RANK_BADGE_SHEET_HEIGHT;
  const ctx = canvas.getContext("2d");
  if (!ctx) {
    throw new Error("crop ภาพไม่สำเร็จ");
  }
  ctx.drawImage(
    image,
    rect.sx,
    rect.sy,
    rect.sw,
    rect.sh,
    0,
    0,
    RANK_BADGE_SHEET_WIDTH,
    RANK_BADGE_SHEET_HEIGHT,
  );
  if (options?.removeWhiteBg) {
    applyRemoveWhiteBackgroundToCanvas(ctx, RANK_BADGE_SHEET_WIDTH, RANK_BADGE_SHEET_HEIGHT);
  }
  if (options?.removeBlackBg) {
    const imageData = ctx.getImageData(0, 0, RANK_BADGE_SHEET_WIDTH, RANK_BADGE_SHEET_HEIGHT);
    removeBlackFromImageData(imageData);
    ctx.putImageData(imageData, 0, 0);
  }
  return canvas.toDataURL("image/png");
}
